import { FINANCIAL_PROFILE_QUESTION_GLOBAL_ORDER } from '../OnboardingAgent/FinancialProfilePanel';

/**
 * Sort by {@link FINANCIAL_PROFILE_QUESTION_GLOBAL_ORDER}; unknown ids last, then by id string.
 */
function compareQuestionIdsByFinancialProfilePanel(aId, bId) {
  const oa = FINANCIAL_PROFILE_QUESTION_GLOBAL_ORDER[aId];
  const ob = FINANCIAL_PROFILE_QUESTION_GLOBAL_ORDER[bId];
  const va = oa === undefined ? Number.MAX_SAFE_INTEGER : oa;
  const vb = ob === undefined ? Number.MAX_SAFE_INTEGER : ob;
  if (va !== vb) return va - vb;
  return String(aId || '').localeCompare(String(bId || ''));
}

/**
 * Order category questions to match FinancialProfilePanel / {@link FINANCIAL_PROFILE_QUESTION_GLOBAL_ORDER}.
 * @param {Object} category - Category object with questions array
 * @returns {Object} - Category object with ordered questions
 */
export const processCategoryQuestions = (category) => {
  const originalQuestions = Array.isArray(category.questions) ? category.questions : [];
  const validQuestions = originalQuestions.filter((q) => q);

  const orderedQuestions = [...validQuestions].sort((a, b) =>
    compareQuestionIdsByFinancialProfilePanel(a?.id, b?.id)
  );

  return {
    ...category,
    questions: orderedQuestions,
  };
};
